import { Component, OnInit, OnDestroy, Sanitizer } from '@angular/core';
import { ShellUpdateService, ShellUpdateMessage, ShellActionMessage } from '../../services/shell-update-service/shell-update.service';
import { AppConfigService } from '../../services/app-config-service/app-config.service';
import { Credentials } from '../../domain/credentials';
import { Router, ActivatedRoute } from '@angular/router';
import { Response } from '@angular/http';
import { AuthHttpClient } from '../../services/auth-http-service/auth-http.service';
import { Subscription } from 'rxjs/Subscription';
import { LoggingService } from '../../services/logging-service/logging.service';
import { ViewChild } from '@angular/core';
import { ElementRef, AfterViewInit } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { MatSnackBar } from '@angular/material';
import { PatientDataService } from '../../services/patient-data/patient-data.service';
import { DateInputComponent } from '../../components/date-input/date-input.component';
import { UserSessionService } from '../../services/user-session-service/user-session.service';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { AssetService } from '../../services/asset-service/asset.service';
import { DomSanitizer } from '@angular/platform-browser';
import { TrustDataService } from '../../services/trust-data-service/trust-data.service';
import { pipe } from 'rxjs/util/pipe';
import { map } from 'rxjs/operators';



@Component({
  selector: 'app-portal-login-view',
  templateUrl: './portal-login-view.component.html',
  styleUrls: ['./portal-login-view.component.css']
})

export class PortalLoginViewComponent implements OnInit, AfterViewInit {

  // Model for storing the credentials
  attemptingLogin: boolean;
  credentials: Credentials;
  loginSubscription: Subscription;
  targetRoute: Subscription;
  userSessionSubscription: Subscription;
  target: string;
  patient: any;
  testDate: string;
  trustLogo: any;
  loaded: boolean;

  @ViewChild('userName') vc: ElementRef;
  @ViewChild('dateControl') dc: DateInputComponent;

  // Services are injected here
  constructor(private shellUpdateService: ShellUpdateService,
    public appConfigService: AppConfigService, private router: Router, private route: ActivatedRoute,
    private authHttp: AuthHttpClient, public loggingService: LoggingService, private snackBar: MatSnackBar,
    private patientDataService: PatientDataService, private userSessionService: UserSessionService,
    private breakpointObserver: BreakpointObserver, private assetService: AssetService, private sanitizer: DomSanitizer,
    private trustService: TrustDataService) {

  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.vc.nativeElement.focus();
    });
  }

  ngOnInit() {

    // Update the headers and footers
    this.shellUpdateService.sendShellUpdateMessage(new ShellUpdateMessage(
      this.appConfigService.ApplicationName, null, null, null));

    // Show / Hide certain components such as burger menu etc
    this.credentials = new Credentials();
    this.loaded = true;

    // Monitor login progress and wait for status updates from the subscription
    this.userSessionSubscription = this.userSessionService.login(null).subscribe(loggedIn => {
      if (loggedIn) {
        // The route guard service may have sent the user here as they are not logged in. But, this may also be for other genuine cases.
        this.targetRoute = this.route.queryParams.subscribe(params => {
          if ((params['target'] !== '/app/logout') && (params['target'] === '/app/registration'
            && params['target'] === '/app/newpassword')) {
            this.target = params['target'];
          } else {
            this.target = null;
          }
        });
        this.redirect();
      }
      this.attemptingLogin = false;
    });
  }

  bypassTrust(url: any) {
    return this.sanitizer.bypassSecurityTrustUrl(url);
  }

  /** Authenticates a user against the API */
  authenticate() {
    this.attemptingLogin = true;
    this.loggingService.log(this.appConfigService.AuthenticationLogInUrl, this.appConfigService.LogToConsole);
    this.userSessionService.login(this.credentials).subscribe(loggedIn => {
      if (loggedIn) {
        this.redirect();
      } else {
        this.attemptingLogin = false;
      }
    });
  }

  /** Redirects the user to a different view if a target has been specified  */
  redirect() {
    if (this.target) {
      this.router.navigate([this.target]).catch(error => {
        this.loggingService.log('Error activating route', this.appConfigService.LogToConsole);
      });
    } else {
      if (this.appConfigService.IsTrust) {
        this.router.navigate(['app/admin/search']).catch(error => {
          this.loggingService.log('Error activating route app/admin/search', this.appConfigService.LogToConsole);
        });
      } else {
        this.router.navigate(['app/home']).catch(error => {
          this.loggingService.log('Error activating route app/details', this.appConfigService.LogToConsole);
        });
      }
    }
  }

  OnDestroy() {
    if (this.loginSubscription) {
      this.loginSubscription.unsubscribe();
    }

    if (this.targetRoute) {
      this.targetRoute.unsubscribe();
    }

  }

}



// WEBPACK FOOTER //
// ./src/app/views/portal-login-view/portal-login-view.component.ts